import { toast } from 'sonner'

/**
 * Copia el enlace de una reunión al portapapeles.
 *
 * Copiar y no abrir: el caso de uso es pegarlo en un chat para compartirlo, no entrar al meet.
 */
export const copiarEnlaceMeet = async (url: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(url)
    toast.success('Enlace copiado')
  } catch {
    // El portapapeles falla sin permiso o fuera de un gesto del usuario: avisar, no romper.
    toast.error('No se pudo copiar el enlace')
  }
}
